export default __webpack_public_path__ + "static/media/small-rombus.baa6d3c7.svg";